import { t } from '@lingui/core/macro';
import { addDays, format, parseISO } from 'date-fns';
import { TFilter } from 'types';
import {
  ALL_STATUS_VALUES,
  EXPIRING_STATUS_VALUES,
  OFFERED_STATUS_VALUES,
  PENDING_STATUS_VALUES,
} from 'utils/applications/applications.config';

const EXPIRING_WINDOW_DAYS = 5;
const DATE_FORMAT = 'yyyy-MM-dd';

export const getExpiringDateRange = (from = new Date()): [string, string] => [
  format(from, DATE_FORMAT),
  format(addDays(from, EXPIRING_WINDOW_DAYS), DATE_FORMAT),
];

export const isExpiringDateRange = ([from, to]: [string, string]) =>
  Boolean(from && to) && getExpiringDateRange(parseISO(from))[1] === to;

export const isExpiring = (timeout: string) => {
  const todaysDate = new Date();
  const timeoutDate = new Date(timeout);
  timeoutDate.setUTCHours(23, 59, 59, 999);
  const daysTilExpiry = Math.round(
    (timeoutDate.getTime() - todaysDate.getTime()) / (1000 * 3600 * 24),
  );
  if (daysTilExpiry >= 0 && daysTilExpiry <= EXPIRING_WINDOW_DAYS) {
    return true;
  }
  return false;
};

export const FILTER_OPTIONS = (): TFilter[] => [
  {
    id: 'all',
    label: t`All apps`,
    propertiesToFilterOn: ALL_STATUS_VALUES,
  },
  {
    id: 'pending',
    label: t`Pending`,
    propertiesToFilterOn: PENDING_STATUS_VALUES,
    displayQuantity: true,
  },
  {
    id: 'review',
    label: t`Offered`,
    propertiesToFilterOn: OFFERED_STATUS_VALUES,
    displayQuantity: true,
  },
  {
    id: 'expiring',
    label: t`Expiring`,
    propertiesToFilterOn: EXPIRING_STATUS_VALUES,
    displayQuantity: true,
  },
];
